import {FCWithHTMLAttributes} from "../types/reactTypes";
import clsMerge from "../util/clsMerge";

export enum AlertType {
	ERROR = "error",
	WARNING = "warning",
	INFO = "info",
	SUCCESS = "success",
}

const colorClassesByAlertType = {
	[AlertType.ERROR]:
		"bg-semantic-error-100 text-semantic-error-500 border-semantic-error-300",
	// TODO: We don't have colors for the other types yet - see tailwind.config.ts under "semantic"
	[AlertType.WARNING]: "TBD",
	[AlertType.INFO]:
		"bg-semantic-info-100 text-semantic-info-500 border-semantic-info-300",
	[AlertType.SUCCESS]:
		"bg-semantic-success-100 text-semantic-success-500 border-semantic-success-300",
};

interface AlertBoxProps {
	type: AlertType;
}

const AlertBox: FCWithHTMLAttributes<AlertBoxProps> = ({
	type,
	children,
	className,
}) => {
	const colorClasses = colorClassesByAlertType[type];
	return (
		<div className={clsMerge("border-l-8 px-4 py-2", colorClasses, className)}>
			{children}
		</div>
	);
};

export default AlertBox;
